import React from "react";
import { Route, Routes } from "react-router-dom";

// Components
import {
  JoinOurTeam,
  TeamAll,
  TeamAurora,
  TeamJustine,
  TeamMunch,
  TeamSeeley,
  TeamZeta,
} from "../Components";

export const About = () => {
  return (
    <>
      <Routes>
        <Route path="aurora" element={<TeamAurora />} />
        <Route path="justine" element={<TeamJustine />} />
        <Route path="join-our-team" element={<JoinOurTeam />} />
        <Route path="in-memory-of-munch" element={<TeamMunch />} />
        <Route path="seeley" element={<TeamSeeley />} />
        <Route path="zeta" element={<TeamZeta />} />
        <Route path="/" element={<TeamAll />} />
      </Routes>
    </>
  );
};
